const APP_VERSION = "2026-04-22-pwa-reset-2";
const APP_VERSION_KEY = "mfDashboardAppVersion";

export function syncAppVersion() {
  try {
    const savedVersion = localStorage.getItem(APP_VERSION_KEY);

    if (savedVersion === APP_VERSION) {
      return;
    }

    // Сбрасываем только те локальные данные, которые могут тянуть старую картину
    localStorage.removeItem("eventsData");
    localStorage.removeItem("eventsDataTimestamp");
    localStorage.removeItem("dashboardActionOrder");
    localStorage.removeItem("dashboardActiveTab");
    localStorage.removeItem("dashboardEventsMobileTab");

    localStorage.setItem(APP_VERSION_KEY, APP_VERSION);
  } catch (error) {
    console.error("App version sync failed:", error);
  }
}